import { $AjaxJson } from '@/lf'
import { $Urlpath, $UrlApipath } from '@/config/config'
export const OrderRequest = {

    GetOrder(func, ID) {
        $AjaxJson($UrlApipath + "Order/GetOrder", { ID: ID }, function(d) {
            func(d)
        })
    },
    SearchShopCustomerToken(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchShopCustomerToken", obj, function(d) {
            func(d)
        })
    },
    OrderLabelGer(func, obj) {
        $AjaxJson($UrlApipath + "Order/OrderLabelGer", obj, function(d) {
            func(d)
        })
    },
    AddOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/AddOrder", obj, function(d) {
            func(d)
        })
    },
    AddOrderAfter(func, obj) {
        $AjaxJson($UrlApipath + "Order/OperateOrderAfter", obj, function(d) {
            func(d)
        })
    },
    AddOrderAfterList(func, obj) {
        $AjaxJson($UrlApipath + "Order/AddAfterSales", obj, function(d) {
            func(d)
        })
    },


    GetOrderByOrderNoOrTrackingNo(func, OrderNoOrTrackingNo, IncludePaths) {
        $AjaxJson($UrlApipath + "Order/GetOrderByOrderNoOrTrackingNo", { OrderNoOrTrackingNo: OrderNoOrTrackingNo, IncludePaths: IncludePaths }, function(d) {
            func(d)
        })

    },
    SearchOrderDetailed(func, OrderNoOrTrackingNo,incheck) {
        $AjaxJson($UrlApipath + "Order/SearchOrderDetailed", { OrderNO: OrderNoOrTrackingNo,incheck:incheck }, function(d) {
            func(d)
        })

    },
    DeclareOrderCheckSKU(func, obj) {
        $AjaxJson($UrlApipath + "Order/DeclareOrderCheckSKU", obj, function(d) {
            func(d)
        })
    },


    UpdateSkuEnName(func,obj){

        $AjaxJson($UrlApipath + "Order/UpdateSkuEnName", obj, function(d) {
            func(d)
        })  

    },


    AddOrders(func, obj) {
        $AjaxJson($UrlApipath + "Order/AddOrders", obj, function(d) {
            func(d)
        })
    },

    UpdateOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/UpdateOrder", obj, function(d) {
            func(d)
        })
    },
    UpdateOrderInfo(func, obj) {
        $AjaxJson($UrlApipath + "Order/UpdateOrderInfo", obj, function(d) {
            func(d)
        })
    },

    UploadTrackingNos(func, obj) {
        $AjaxJson($UrlApipath + "Order/UploadTrackingNos", obj, function(d) {
            func(d)
        })
    },
    CopyOrderList(func, obj) {
        $AjaxJson($UrlApipath + "Order/CopyOrderList", obj, function(d) {
            func(d)
        })
    },
    //更新订单信息-问题件
    UploadBatchUpdateOrderInfo(func, obj) {
        $AjaxJson($UrlApipath + "Order/UploadBatchUpdateOrderInfo", obj, function(d) {
            func(d)
        })
    },
 

    SearchOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchOrder", obj, function(d) {
            func(d)
        })
    },
    SeachAftetSales(func, obj) {
        $AjaxJson($UrlApipath + "Order/SeachAftetSales", obj, function(d) {
            func(d)
        })
    },

    SeachFirstAfterSales(func, obj) {
        $AjaxJson($UrlApipath + "Order/FirstAfterSales", obj, function(d) {
            func(d)
        })
    },

    

    SearchOrderNewM(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchOrderNewM", obj, function(d) {
            func(d)
        })
    },
    SearchOrderList(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchOrderList", obj, function(d) {
            func(d)
        })
    },


    SetOrderSalesID(func, ID, SalesID) {
        $AjaxJson($UrlApipath + "Order/SetOrderSalesID", { ID: ID, SalesID: SalesID }, function(d) {
            func(d)
        })
    },

    SetOrderIsSignFlag(func, ID, IsSignFlag) {
        $AjaxJson($UrlApipath + "Order/SetOrderIsSignFlag", { ID: ID, IsSignFlag: IsSignFlag }, function(d) {
            func(d)
        })
    },
    SetOrderIsBatteryFlag(func, ID, IsBatteryFlag) {
        $AjaxJson($UrlApipath + "Order/SetOrderIsBatteryFlag", { ID: ID, IsBatteryFlag: IsBatteryFlag }, function(d) {
            func(d)
        })
    },
    SetOrderOrderStatus(func, ID, OrderStatus) {
        $AjaxJson($UrlApipath + "Order/SetOrderOrderStatus", { ID: ID, OrderStatus: OrderStatus }, function(d) {
            func(d)
        })
    },
    SetOrderIsQuestion(func, ID, IsQuestion) {
        $AjaxJson($UrlApipath + "Order/SetOrderIsQuestion", { ID: ID, IsQuestion: IsQuestion }, function(d) {
            func(d)
        })
    },
    SetOrderIsOrderChecks(func, ID, IsOrderChecks) {
        $AjaxJson($UrlApipath + "Order/SetOrderIsOrderChecks", { ID: ID, IsOrderChecks: IsOrderChecks }, function(d) {
            func(d)
        })
    },
    AddOrderPrintTimes(func, ID, PrintTimes) {
        $AjaxJson($UrlApipath + "Order/AddOrderPrintTimes", { ID: ID, PrintTimes: PrintTimes }, function(d) {
            func(d)
        })
    },

    SetOrderOrderSource(func, ID, OrderSource) {
        $AjaxJson($UrlApipath + "Order/SetOrderOrderSource", { ID: ID, OrderSource: OrderSource }, function(d) {
            func(d)
        })
    },

    SetOrderIsPlatFormTrackFlag(func, ID, IsPlatFormTrackFlag) {
        $AjaxJson($UrlApipath + "Order/SetOrderIsPlatFormTrackFlag", { ID: ID, IsPlatFormTrackFlag: IsPlatFormTrackFlag }, function(d) {
            func(d)
        })
    },

    SetOrderIsBillFlag(func, ID, IsBillFlag) {
        $AjaxJson($UrlApipath + "Order/SetOrderIsBillFlag", { ID: ID, IsBillFlag: IsBillFlag }, function(d) {
            func(d)
        })
    },

    OrderSubmit(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderSubmit", d, function(d) {
            func(d)
        })
    },

    OrderSplit(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderSplitCustomized", d, function(d) {
            func(d)
        })
    },


    ChangeOrderState(func, obj) {
        $AjaxJson($UrlApipath + "Order/ChangeOrderState", obj, function(d) {
            func(d)
        })
    },
    ChangeProcessing(func, obj) {
        $AjaxJson($UrlApipath + "Order/ChangeProcessing", obj, function(d) {
            func(d)
        })
    },
    RecallOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/RecallOrder", obj, function(d) {
            func(d)
        })
    },
    UpdateOrders(func, d) {
        $AjaxJson($UrlApipath + "Order/UpdateOrders", d, function(d) {
            func(d)
        })
    },

    MergeOrder(func, d) {
        $AjaxJson($UrlApipath + "Order/MergeOrder", d, function(d) {
            func(d)
        })
    },

    // 批量合并订单
    MergeOrderS(func, d) {
        $AjaxJson($UrlApipath + "Order/MergeOrderS", d, function(d) {
            func(d)
        })
    },

    ExportOrder(func, d) {
        $AjaxJson($UrlApipath + "Order/ExportOrder", d, function(d) {
            func(d)
        })
    },

    OrderSubmit(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderSubmit", d, function(d) {
            func(d)
        })

    },

    CopyOrder(func, d) {
        $AjaxJson($UrlApipath + "Order/CopyOrder", d, function(d) {
            func(d)
        })
    },

    OrderStatusByVoid(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderStatusByVoid", d, function(d) {
            func(d)
        })
    },

    OrderDelDetails(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderDelDetails", d, function(d) {
            func(d)
        })
    },

    MarkingOrder(func, d) {
        $AjaxJson($UrlApipath + "Order/MarkingOrder", d, function(d) {
            func(d)
        })
    },

    OrderPaySubmit(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderPaySubmit", d, function(d) {
            func(d)
        })
    },

    OrderToDraft(func, d) {
        $AjaxJson($UrlApipath + "Order/OrderToDraft", d, function(d) {
            func(d)
        })
    },



    CutOffOrder(func, d) {
        $AjaxJson($UrlApipath + "Order/CutOffOrder", d, function(d) {
            func(d)
        })
    },

    GetUPSOrderTrackingNo(func, d) {
        $AjaxJson($UrlApipath + "Order/GetUPSOrderTrackingNo", d, function(d) {
            func(d)
        })
    },

    DeleteOrder(func, d) {
        $AjaxJson($UrlApipath + "Order/DeleteOrder", d, function(d) {
            func(d)
        })
    },


    CollectGoodsAndGetOrder(func, OrderNo, Weight, PackageFee,isJump,Len,Wid,High) {
        $AjaxJson($UrlApipath + "Order/CollectGoodsAndGetOrder", {
              OrderNo: OrderNo,
              Weight: Weight,
              PackageFee: PackageFee,
              isJump: isJump,
              Len:Len,
              Wid:Wid,
              High:High
              },
              function (d) {
            func(d)
        })
    },
    CollectGoodsAndGetOrderS(func, OrderNo, Weight, PackageFee,isJump,Len,Wid,High) {
        $AjaxJson($UrlApipath + "Order/CollectGoodsAndGetOrderS", {
              OrderNo: OrderNo,
              Weight: Weight,
              PackageFee: PackageFee,
              isJump: isJump,
              Len:Len,
              Wid:Wid,
              High:High
              },
              function (d) {
            func(d)
        })
    },
    GetCollectGoodsFee(func, d) {
        $AjaxJson($UrlApipath + "Order/GetCollectGoodsFee", d, function(d) {
            func(d)
        })
    },

    CollectGoods(func, d) {
        $AjaxJson($UrlApipath + "Order/CollectGoods", d, function(d) {
            func(d)
        })
    },



    SearchOrderDetail(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchOrderDetail", obj, function(d) {
            func(d)
        })
    },


    SearchOrderDetailByPickUpBatch(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchOrderDetailByPickUpBatch", obj, function(d) {
            func(d)
        })
    },



    SearchSKUCounts(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchSKUCounts", obj, function(d) {
            func(d)
        })
    },




    GetOrdersByPlatForm(func, obj) {
        $AjaxJson($UrlApipath + "Order/GetOrdersByPlatForm", obj, function(d) {
            func(d)
        })
    },
    Get2157Beppe(func, obj) {
        $AjaxJson($UrlApipath + "Order/Get2157Beppe", obj, function(d) {
            func(d)
        })
    },


    SplitOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/SplitOrder", obj, function(d) {
            func(d)
        })
    },

    UpdateDeclare(func, obj) {
        $AjaxJson($UrlApipath + "Order/UpdateDeclare", obj, function(d) {
            func(d)
        })
    },

    FreightInquiries(func, obj) {
        $AjaxJson($UrlApipath + "Order/FreightInquiries", obj, function(d) {
            func(d)
        })
    },


    CancelOrder(func, OrderNoOrTrackingNo) {
        $AjaxJson($UrlApipath + "Order/CancelOrder", { OrderNoOrTrackingNo: OrderNoOrTrackingNo }, function(d) {
            func(d)
        })
    },


    UploadAfterShip(func, obj) {
        $AjaxJson($UrlApipath + "Order/UploadAfterShip", obj, function(d) {
            func(d)
        })
    },





    OrderChoose(func) {

        $AjaxJson($UrlApipath + "Order/OrderChoose", {}, function(d) {
            func(d)
        })
    },

    UpdateShopify(func, obj) {
        $AjaxJson($UrlApipath + "Order/UpdateShopify", obj, function(d) {
            func(d)
        })
    },

    UpdateYUNTU(func, obj) {
        $AjaxJson($UrlApipath + "Order/UpdateYUNTU", obj, function(d) {
            func(d)
        })
    },
    InterceptOredr(func, obj) {
        $AjaxJson($UrlApipath + "Order/InterceptOredr", obj, function(d) {
            func(d)
        })
    },



    TrackingOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/TrackingOrder", obj, function(d) {
            func(d)
        })
    },


    RemarkOrder(func, obj) {
        $AjaxJson($UrlApipath + "Order/RemarkOrder", obj, function(d) {
            func(d)
        })
    },

    SyncSkuMappingOrder(func) {

        $AjaxJson($UrlApipath + "Order/SyncSkuMappingOrder", {}, function(d) {
            func(d)
        })
    },
    SyncMappingOrder(func) {

        $AjaxJson($UrlApipath + "Order/SyncMappingOrder", {}, function(d) {
            func(d)
        })
    }

}



// WEBPACK FOOTER //
// ./src/request/Order.js